<template>
  <div class="main" style="margin: 0 auto">
<!--    <transition name="el-fade-in-linear" mode="out-in">-->
      <router-view :key="key" />
<!--    </transition>-->
  </div>
</template>

<script>
export default {
  name: "Main",
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style scoped>

</style>

